export default {
  title: '管理仓库授权',
  subtitle: 'WMS帐号已具备，通过关联的Xed帐号使用。',
  linkedAuthorizedStores: '关联的授权店铺',
  applyLog: '仓库使用权申请日志',
  warehouseNum: '仓库编号',
  warehouseName: '仓库名',
  country: '国家',
  city: '城市',
  state: '状态',
  applyState: '申请状态',
  auditedState: '审核状态',
  applyTime: '申请时间',
  authorizedTime: '审核时间',
  applyRecord: '申请记录',
  apply: '申请',
  log: '日志',
  authorized: '已审核',
  unauthorized: '未审核',
  noApplyInProgress: '无进行中的申请',
  underReview: '审核中',
  platformName: '平台名',
  storeName: '店铺名',
  storeId: '店铺ID',
  logId: '记录 ID',
  storageLocationName: '库位名',
  serialNumber: '编号',
  passed: '已通过',
  rejected: '已拒绝'
}
